import script from "./QRTemplateFive.vue?vue&type=script&lang=ts&setup=true"
export * from "./QRTemplateFive.vue?vue&type=script&lang=ts&setup=true"

import "./QRTemplateFive.vue?vue&type=style&index=0&id=cc291148&lang=css"
/* custom blocks */
import block0 from "./QRTemplateFive.vue?vue&type=custom&index=0&blockType=i18n&lang=jsonc"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__